var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LandCard',{attrs:{"title":"交易流转区域面积排名","isLeftMore":false}},[[_c('RankCard',{staticClass:"rankCardStyle",attrs:{"list":_vm.data,"barColor":_vm.itemColor}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }